import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { useSettingsLdFlags } from '../launch-darkly'

export type VisibleCatalogueSetting = 'product-catalogue' | 'punchout-catalogues' | 'hosted-catalogues'

export const useVisibleCatalogueSettings = (): VisibleCatalogueSetting[] => {
  const { user } = useAuthenticatedUser()
  const { PRODUCTS_AND_SERVICES_CATALOGUE, PUNCHOUT_CATALOGUES, HOSTED_CATALOGUES } = useFeatureFlags()
  const { SHOW_PUNCHOUT_CATALOGUES } = useSettingsLdFlags()

  const visible: VisibleCatalogueSetting[] = []
  if (PRODUCTS_AND_SERVICES_CATALOGUE) visible.push('product-catalogue')
  if (user.isOmnean && PUNCHOUT_CATALOGUES && SHOW_PUNCHOUT_CATALOGUES) visible.push('punchout-catalogues')
  if (HOSTED_CATALOGUES) visible.push('hosted-catalogues')
  return visible
}
